/**
 * Options for the "ASA Classification" dropdown in the Coding section (feature 034).
 * ASA physical-status classes P1–P6 (per product, 2026-06-07).
 */
export interface ASAClassificationOption {
  /** Stored value (sent on the wire / persisted). */
  value: string;
  /** Display label shown in the dropdown. */
  label: string;
}

export const ASA_CLASSIFICATION_OPTIONS: readonly ASAClassificationOption[] = [
  { value: 'P1', label: 'P1' },
  { value: 'P2', label: 'P2' },
  { value: 'P3', label: 'P3' },
  { value: 'P4', label: 'P4' },
  { value: 'P5', label: 'P5' },
  { value: 'P6', label: 'P6' },
];
